import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const autoCloseTime = 2000;
const Toast = {
    success: (message, options = {}) =>
        toast.success(message, { position: 'top-right', autoClose: autoCloseTime, ...options }),

    error: (message, options = {}) =>
        toast.error(message, { position: 'top-right', autoClose: autoCloseTime, ...options }),

    info: (message, options = {}) =>
        toast.info(message, { position: 'top-right', autoClose: autoCloseTime, ...options }),

    warn: (message, options = {}) =>
        toast.warn(message, { position: 'top-right', autoClose: autoCloseTime, ...options }),
};

export default Toast;
